<template>
  <div id="referrals">
    <!-- ROW 1-->
    <div class="vx-row mb-base">
      <div class="vx-col lg:w-1/3 w-full">

          <div class="vx-row">
              <div class="vx-col w-1/2 ">
                <statistics-card-line
                  hideChart
                  class="mb-base"
                  icon="UserPlusIcon"
                  :statistic="userReferral.length"
                  color="danger"
                  statisticTitle="تعداد معرفی ها" />
              </div>
              <div class="vx-col w-1/2 ">
                <statistics-card-line
                  hideChart
                  class="mb-base"
                  icon="ListIcon"
                  statisticTitle="تعداد تراکنش ها"
                  :statistic="referralTransactionCount"
                  color="success" />
              </div>

              <div class="vx-col w-full md:pb-0 pb-6">
                <statistics-card-line
                  hideChart
                  svgClasses="h-12 w-12"
                  icon="DollarSignIcon"
                  icon-right
                  :statistic="'~'+transactionAmount.toLocaleString('en-US')"
                  color="warning"
                  statisticTitle="مجموع درآمد شما بر اساس تومان" />
              </div>
          </div>

      </div>
      <div class="vx-col lg:w-2/3 w-full">
        <vx-card title="لینک و کد معرفی">
          <p>
            با ارائه لینک یا کد معرفی به دوستان خود میتوانید از کارمزد معاملات آنها کسب درآمد کنید و همچنین بخشی از این درآمد را به خود آنها اختصاص دهید که هم به نفع آنها و هم به نفع شما میباشد.
          </p>
          <div class="vx-row mt-4">
              <div class="vx-col lg:w-1/3 w-full">
                <vs-tooltip color="success" :text="$t('click for copy')">
                  <vs-input class="w-full" size="large" label="کد معرفی" readonly v-model="referralCode"
                            v-clipboard:copy="referralCode"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onError"/>
                </vs-tooltip>
              </div>
              <div class="vx-col lg:w-2/3 w-full flex mt-3 lg:mt-0">
                  <vs-input class="w-full text" size="large" label="لینک معرفی" readonly v-model="referralLink"/>
                  <vs-button class="ml-2 mt-6 lg:px-6 px-4"
                             v-clipboard:copy="referralLink"
                             v-clipboard:success="onCopy"
                             v-clipboard:error="onError">
                    <i class="feather icon-copy"></i>
                  </vs-button>
              </div>
          </div>
          <vs-divider/>
          <div class="mt-5 flex flex-wrap">
              <p class="mt-3">اگر نیاز به کمک دارید فیلم راهنمای این بخش را مشاهده کنید.
              </p>
              <vs-button color="warning" :href="videoLearn.referral" target="_blank" class="mx-2" type="border"  icon-pack="feather" icon="icon-play">فیلم راهنما</vs-button>
          </div>
        </vx-card>
      </div>
    </div>


    <div class="vx-row mb-base">
      <div class="vx-col w-full">
        <vx-card collapseAction title="تنظیم درصد برای معرفی شده ها">
          <p>
            مقدار <span class="text-bold-700 text-warning">30%</span> درصد از کارمزد معاملات دوستان برای شما در نظر گرفته شده است و با تنظیم این بخش میتوانید درآمد خود را بین افرادی که معرفی کرده اید تقسیم کنید.
            <br>
            در این بخش میتوانید درصد اهدایی به دوستان را تعیین کنید:
          </p>
          <div class="mt-4 text-center">


              <vs-button color="primary" class="px-5 mr-2 mt-1" type="border" :class="referralsPercent == 0 ? 'isActive bg-primary' :''" @click="changeReferralsPercent(0)">0%</vs-button>
              <vs-button color="primary" class="px-5 mr-2 mt-1" type="border" :class="referralsPercent == 5 ? 'isActive bg-primary' :''" @click="changeReferralsPercent(5)">5%</vs-button>
              <vs-button color="primary" class="px-4 mr-2 mt-1" type="border" :class="referralsPercent == 10 ? 'isActive bg-primary' :''" @click="changeReferralsPercent(10)">10%</vs-button>
              <vs-button color="primary" class="px-4 mr-2 mt-1" type="border" :class="referralsPercent == 15 ? 'isActive bg-primary' :''" @click="changeReferralsPercent(15)">15%</vs-button>
              <vs-button color="primary" class="px-4 mr-2 mt-1" type="border" :class="referralsPercent == 20 ? 'isActive bg-primary' :''" @click="changeReferralsPercent(20)">20%</vs-button>
              <vs-button color="primary" class="px-4 mr-2 mt-1" type="border" :class="referralsPercent == 25 ? 'isActive bg-primary' :''" @click="changeReferralsPercent(25)">25%</vs-button>
              <vs-button color="primary" class="px-4 mr-2 mt-1" type="border" :class="referralsPercent == 30? 'isActive bg-primary' :''" @click="changeReferralsPercent(30)">30%</vs-button>

              <div class="vx-col lg:w-3/5 w-full mt-4 mx-auto vx-row">
                <div class="vx-col lg:w-1/2 w-full">
                  <statistics-card-line
                    hideChart
                    class="border-1 border-solid border-warning"
                    icon="UserIcon"
                    icon-right
                    color="warning"
                    :statistic="30 - referralsPercent + '%'"
                    statisticTitle="سهم شما" />
                </div>
                <div class="vx-col lg:w-1/2 w-full mt-3 lg:mt-0">
                  <statistics-card-line
                    hideChart
                    class="border-1 border-solid border-success"
                    icon="UsersIcon"
                    icon-right
                    color="success"
                    :statistic="referralsPercent + '%'"
                    statisticTitle="سهم دوستان" />
                </div>
              </div>
          </div>
        </vx-card>
      </div>
    </div>

    <!-- Reports -->
    <reports :referralTransactionCount="referralTransactionCount" :userReferral="userReferral"/>

    <!-- Chart -->
    <chart/>


  </div>
</template>

<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import reports from './reports'
import chart from './chart'
import axios from '../../../axios'

export default {
  name: 'referrals',
  data () {
    return {
      referralLink: '',
      referralCode: '',
      userReferral: [] ,
      referralTransactionCount: 0 ,
      transactionAmount: 0 ,

      referralsPercent: 0
    }
  },
  computed: {

  },
  components: {
    StatisticsCardLine,
    reports,
    chart
  },
  methods:{
    changeReferralsPercent (percent) {
      this.referralsPercent = percent
      const self = this
      axios.post('/referrals/set-percent',{referralsPercent: this.referralsPercent})
        .then(function (response) {
          if (response.data.status == true) {
            self.updateUser();
            self.$vs.notify({title: self.$t('Success'), text: response.data.msg, iconPack: 'feather', icon: 'icon-check-circle', color: 'success'})
          } else {
            self.$vs.notify({title: self.$t('Error'), text: response.data.msg, iconPack: 'feather', icon: 'icon-alert-circle', color: 'danger'})
          }
        }).catch(function (error) { console.log(error); })
    },
    getReports(){
      const self = this
      axios.post('/referrals/get-reports')
        .then(function (response) {
          self.referralsPercent = response.data.referralPercent
          self.referralLink = response.data.reflink
          self.referralCode = response.data.refid
          self.userReferral = response.data.user_referral
          self.referralTransactionCount = response.data.referral_transaction_count
          self.transactionAmount = response.data.referral_transaction_amount

          /*if( response.data.notif === true)
            self.$store.dispatch('SET_REFRESH_NOTIF', {status: !self.refreshNotifications})*/

      }).catch(function (error) { console.log(error); })
    }
  },
  mounted () {

  },
  created () {
    this.getReports();
  }
}
</script>

<style lang="scss">


  #referrals{

    .vs-input--input.large{
      text-align: center;
    }
    .vs-input--label{
      font-size: 15px;
    }
  }
</style>
